export const ROLE_ADMIN = "ROLE_ADMIN"
export const ROLE_COACH = "ROLE_COACH"
export const ROLE_SUPER_ADMIN = "ROLE_SUPER_ADMIN"
export const ROLE_SERVICE = "ROLE_SERVICE"